module.exports = __webpack_public_path__ + "static/media/Korea.cb7294d4.png";